export enum OrganizationIndustry {
  Automotive = 1,
  AdvertisingMediaCommunications,
  Healthcare,
  CharityOrNonProfit,
  ConsultingDesignEducation,
  Entertainment,
  Electronics,
  FinancialService,
  SoftwareServices,
  ImportingGoods,
  Manufacturing,
  Pharmaceuticals,
  RealEstate,
  Food,
  Travel,
  Other = 1000
}

// tslint:disable-next-line:no-namespace
export namespace OrganizationIndustry {
  export function toString(industry: OrganizationIndustry): string {
    switch (industry) {
      case OrganizationIndustry.Automotive:
        return 'Automotive';
      case OrganizationIndustry.AdvertisingMediaCommunications:
        return 'Advertising media communications';
      case OrganizationIndustry.Healthcare:
        return 'Healthcare';
      case OrganizationIndustry.CharityOrNonProfit:
        return 'Charity or non-profit';
      case OrganizationIndustry.ConsultingDesignEducation:
        return 'Consulting design education';
      case OrganizationIndustry.Entertainment:
        return 'Entertainment';
      case OrganizationIndustry.Electronics:
        return 'Electronics';
      case OrganizationIndustry.FinancialService:
        return 'Financial service';
      case OrganizationIndustry.SoftwareServices:
        return 'Software services';
      case OrganizationIndustry.ImportingGoods:
        return 'Importing goods';
      case OrganizationIndustry.Manufacturing:
        return 'Manufacturing';
      case OrganizationIndustry.Pharmaceuticals:
        return 'Pharmaceuticals';
      case OrganizationIndustry.RealEstate:
        return 'Realestate';
      case OrganizationIndustry.Food:
        return 'Food';
      case OrganizationIndustry.Travel:
        return 'Travel';
      case OrganizationIndustry.Other:
        return 'Other';
      default:
        return null;
    }
  }

  export function parse(roleStr: string): OrganizationIndustry {
    return OrganizationIndustry[roleStr];
  }

  export function listAll() {
    return [
      OrganizationIndustry.Automotive,
      OrganizationIndustry.AdvertisingMediaCommunications,
      OrganizationIndustry.Healthcare,
      OrganizationIndustry.CharityOrNonProfit,
      OrganizationIndustry.ConsultingDesignEducation,
      OrganizationIndustry.Entertainment,
      OrganizationIndustry.Electronics,
      OrganizationIndustry.FinancialService,
      OrganizationIndustry.SoftwareServices,
      OrganizationIndustry.ImportingGoods,
      OrganizationIndustry.Manufacturing,
      OrganizationIndustry.Pharmaceuticals,
      OrganizationIndustry.RealEstate,
      OrganizationIndustry.Food,
      OrganizationIndustry.Travel,
      OrganizationIndustry.Other
    ];
  }
}

export default OrganizationIndustry;
